import { Controller } from "@hotwired/stimulus";
import algoliasearch from "algoliasearch/lite";
import instantsearch from "instantsearch.js";
import { toggleSections } from "../section_appearance";
import { configure } from "instantsearch.js/es/widgets";
import searchBoxWidget from "../professionsl_search/search_box_widget";
import hitsWidget from "../professionsl_search/hits_widget";
import servicesRefinementWidget from "../professionsl_search/services_refinement_widget";
import countriesRefinementWidget from "../professionsl_search/countries_refinement_widget";
import accountTypeRefinementWidget from "../professionsl_search/account_type_refinement_widget";
import tagsRefinementWidget from "../professionsl_search/tags_refinement_widget";
import customRatingWidget from "../professionsl_search/customized_rating_widget";
import paginationWidget from "../professionsl_search/pagination_widget";

const searchConfiguration = () =>
  configure({
    hitsPerPage: 12, // changed it to 12 to fit the grid better for different screen size
    filters: "active:true",
  });

export default class ProfessionalSearch extends Controller {
  initialize() {
    this.algoliaId = this.data.get("algoliaId");
    this.algoliaSearchKey = this.data.get("algoliaSearchKey");
    this.countryCode = this.data.get("countryCode");
    this.locale = this.data.get("locale");
    this.indexName = "professional_" + this.locale;
  }

  connect() {
    I18n.locale = this.locale;

    let readyToSearch =
      this.algoliaId &&
      this.algoliaSearchKey &&
      this.locale &&
      this.countryCode;

    if (readyToSearch) {
      this.performSearch();
    }
  }

  performSearch() {
    const client = algoliasearch(this.algoliaId, this.algoliaSearchKey);
    const search = instantsearch({
      indexName: this.indexName,
      searchClient: client,
      routing: true,
      searchFunction(helper) {
        helper.search();
      },
      future: {
        preserveSharedStateOnUnmount: true,
      },
    });

    this.handleSearchLoading(search);

    search.addWidgets([
      searchConfiguration(),
      searchBoxWidget(I18n),
      hitsWidget(this.locale, this.countryCode, I18n),
      servicesRefinementWidget(I18n),
      countriesRefinementWidget(),
      accountTypeRefinementWidget(),
      tagsRefinementWidget(I18n),
      customRatingWidget(),
      paginationWidget(),
    ]);

    search.start();
  }

  handleSearchLoading(search) {
    search.on("render", () => {
      // hide and show the loader based on the search status
      if (search.status === "loading" || search.status === "stalled") {
        toggleSections(true, "search-loading");
        toggleSections(false, "hits");
      } else {
        toggleSections(false, "search-loading");
        toggleSections(true, "hits");
      }
    });
  }
}
